import React, { Component } from 'react';
import globals from '../globals';

class IndigoSection extends Component {

	componentDidMount() {
		this.controller = globals.genericAnimation(this.content);
	}

	componentWillUnmount() {
		globals.destroy(this.controller);
	}

	render() {
		return (
			<section className="indigo-section reverse" ref={el => this.content = el}>
				<div className="inner">
					{this.props.children}
				</div>
				<div className="bottom-wave-darkgreen" />
			</section>
		);
	}

}

export default IndigoSection;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/IndigoSection.js